import { InternData } from '../../types/internData';
import { Profile } from '../../types/enumProfile';
import apiClient from './apiClient';

export const getInternById = async (id: string): Promise<InternData | null> => {
    try {
        const response = await apiClient.get('/users', {
            params: { id }
        });
        const data = response.data.data[0];

        return {
            id: data.id,
            civility: data.civility,
            firstname: data.firstname,
            lastname: data.lastname,
            email: data.email,
            societyId: data.societyId,
            registrationNumber: data.registrationNumber
        };
    } catch (error) {
        console.error('Error fetching intern by ID:', error);
        return null;
    }
};

export const getInternByInfo = async (firstname: string, lastname: string, societyId: string): Promise<InternData | null> => {
    try {
        const response = await apiClient.get('/users', {
            params: { firstname, lastname, societyId }
        });
        const data = response.data.data[0];

        return {
            id: data.id,
            civility: data.civility,
            firstname: data.firstname,
            lastname: data.lastname,
            email: data.email,
            societyId: data.societyId,
            registrationNumber: data.registrationNumber
        };
    } catch (error) {
        console.error('Error fetching intern by info:', error);
        return null;
    }
};

export const createIntern = async (civility: string, firstname: string, lastname: string, societyId: string, email?: string, registrationNumber?: string): Promise<{ status: number; id?: string }> => {
    try {
        const response = await apiClient.post('/users', {
            civility,
            firstname,
            lastname,
            email,
            registrationNumber,
            profile: Profile.TRAINEE,
            active: false,
            societyId
        });

        return { status: response.status, id: response.data.id };
    } catch (error: any) {
        console.error('Error creating intern:', error);
        return { status: error.response?.status || 500 };
    }
};

export const updateIntern = async (id: string, civility: string, firstname: string, lastname: string, societyId: string, email?: string, registrationNumber?: string): Promise<number> => {
    try {
        const response = await apiClient.put(`/users/${id}`, {
            civility,
            firstname,
            lastname,
            email,
            registrationNumber,
            profile: Profile.TRAINEE,
            active: false,
            societyId
        });

        return response.status;
    } catch (error: any) {
        console.error('Error updating intern:', error);
        return error.response?.status || 500;
    }
};
